import { Component, Output, EventEmitter, Input, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-list-action',
  templateUrl: 'list-action.component.html',
})
export class ListActionComponent {

  @Output() public setIdioma = new EventEmitter<any>();

  @Input() public dataValue: string;
  @Input() public indexList: number;
  @Input() public list = [];

  public showDropDown = false;
  @HostListener('document:click', ['$event'])
  onClick(ev) {
    if (this.showDropDown) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.showDropDown = false;
      }
    }
  }

  constructor(
    private eRef: ElementRef,
  ) { }

}